export const environment = {
  production: true,
  mode:{
    dev:false,
    localhost:false,
    prod:true,
    stage:false
  },
  /////
  CURRENT_PATH : 'https://afarine.com/',
  SHARE_PATH : 'https://afarine-production-backend.darkube.ir/',
  BASE_MEDIA_PATH : 'https://afarine-production-backend.darkube.ir/',
  BASE_DEFALT_IMAGE_PATH : 'https://afarine-production-backend.darkube.ir/assets/image/',
  BASE_API_URL : 'https://afarine-production-backend.darkube.ir/api/',
  QUIZ_API_URL : 'https://afarine-back-quiz-production.darkube.ir/api/quiz/', 
}; 
